(function () {
  if (window.__vanemarPerformanceReady) return;
  window.__vanemarPerformanceReady = true;

  var selector = '#MainContent > .shopify-section';
  var pausedClass = 'vm-section-offscreen';

  function observeSections(scope) {
    if (!('IntersectionObserver' in window)) return;

    var roots = [];
    if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    }

    roots.forEach(function (section) {
      if (section.dataset.vmPerformanceObserved === 'true') return;
      section.dataset.vmPerformanceObserved = 'true';
      sectionObserver.observe(section);
    });
  }

  var sectionObserver = null;
  if ('IntersectionObserver' in window) {
    sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle(pausedClass, !entry.isIntersecting);
      });
    }, { rootMargin: '250px 0px', threshold: 0 });

    observeSections(document);
    document.addEventListener('shopify:section:load', function (event) {
      observeSections(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (sectionObserver && event.target) sectionObserver.unobserve(event.target);
    });
  }
})();
